
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'VideoSafari',
    props:{
        source: {
            type: String,
            default: ''
        },
        poster: {
            type: String,
            default: null
        },
        muted:{
            type: Boolean,
            default: true
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        loop:{
            type: Boolean,
            default: false
        },
        showplay: {
            type: Boolean,
            default: false
        }
    },
    data(){
        let player: any|undefined;
        return {
            player,
            isloaded: false,
            sid: Math.floor(Math.random() * 9999),
            stoped: false,
            videoSrc: '',
            lastError: null,
            timeSetSource: null,
            playStarted: false,
            listEvents: ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"]
        }
    },
    mounted() {
        this.listEvents.forEach(eventType => {
            document.addEventListener(eventType, this.fullScreenChange);
        });
        this.setSource();
    },
    beforeDestroy: function () {
        this.listEvents.forEach(eventType => {
            document.removeEventListener(eventType, this.fullScreenChange);
        });
    },
    methods: {
        isFullscreen(){
            let doc: any = document as any;
            return doc.fullscreenElement || doc.msFullscreenElement || doc.mozFullScreen || doc.webkitIsFullScreen;
        },
        fullScreenChange(){
            let isFull    = this.isFullscreen();
            if(!isFull){
                if(this.playStarted){
                    this.$emit('fullscreenexit');
                }
            }
        },
        onplay(){
            this.lastError = null;
            if(!this.playStarted || !this.loop){
                this.setVisible(true);
            }
            this.playStarted = true;
            this.stoped = false;
            this.$emit('onplay', this.player);
        },
        onended(){
            if(!this.loop){
                this.setVisible(false);
            }
            if(this.autoplay){
                setTimeout(() => {this.play()}, 700);
            }
        },
        onabort(){
            this.onended();
        },
        setVisible(val = true){
            let elem: HTMLElement|null = this.$el.querySelector('.player .container');
            if(elem){
                elem.style.opacity = val ? '1' : '0';
            }
        },
        play(){
            if(this.player){
                let promise = this.player.play();
                if (promise !== undefined) {
                    promise.then( (_: any) => {}).catch((error: any) => {
                        if(this.lastError){
                            this.stoped = true;
                            this.$emit('error',error);
                            this.onended();
                        }else{
                            this.player.muted = true;
                            this.lastError    = error;
                            this.play();
                        }
                    });
                }
            }
        },
        stop(){
            if(this.player){
                this.player.pause();
                this.player.currentTime = 0;
                this.onended();
                this.videoSrc = '';
            }
        },
        setSource(){
            let source    = this.source;
            let fristRun  = false;
            if(this.videoSrc != source){
                this.videoSrc = source;
                this.isloaded = true;
                if(!this.player){
                    this.player = document.querySelector('#stream-player' + this.sid);
                    fristRun    = true;
                }
                this.player.src   = this.videoSrc;
                this.player.muted = true;
                this.player.loop  = false;
                this.player.load();
                let timeToPlay    = fristRun ? 750 : 400;
                if(this.autoplay){
                    setTimeout(() => {this.play();}, timeToPlay);
                }
            }
        }
    }
});
